import { error } from "console";

export const wailistPageContent = {
    en: {
        hero:{
            title: "Revimo Prelaunch",
            heading: "Reserve your place for smarter physiotherapy.",
            description: `Join the early waitlist for Revimo, your guided online
              physiotherapy coach. Get a 30% launch discount and be the
              first to know when we go live.`,
            list1: "Daily exercise plans tailored to your recovery.",
            list2: "Clear guidance without waiting room delays.",
            list3: "Fair subscription pricing instead of expensive sessions.",
        },
        form: {
            title: "Join the waitlist",
            description: `Save your 30% launch discount and get early email
                  updates about Revimo. No payment now, just reserve
                  your spot.`,
            calling: "How should we call you?",
            calling2: "Whats your licence number?",
            license: "License number",
            name: "Name",
            get_e: "I want to receive email updates about Revimo and the launch.",
            get_d: "Reserve my 30% launch discount (no payment now, only when we launch)",
            warning: `By joining, you agree that we can store your email for
                        pre‑launch communication. You can opt out of emails at any time.`,
        },
        joining1: "Joining...",
        joining2: "Join the waitlist",
        on_list: "You’re on the list 🎉",
        thanks: "Thank you for reserving your place for Revimo.",
        add_info: `We’ll email you about the launch, your 30% discount, and
                  an invitation to share more feedback so you can help shape
                  the platform.`,
        add_o_e: "Add another email",
        error: "Something went wrong. Please try again in a moment."
    },
    sl: {
    hero: {
      title: "Revimo – predzagonska čakalna lista",
      heading: "Rezervirajte si mesto za pametnejšo fizioterapijo.",
      description: `Pridružite se zgodnji čakalni listi za Revimo – vašega
              spletnega fizioterapevtskega pomočnika. Ob zagonu prejmete
              30 % popust in med prvimi izveste, ko bo storitev na voljo.`,
      list1: "Dnevni načrti vaj, prilagojeni vašemu okrevanju.",
      list2: "Jasna navodila brez čakalnic in zamud.",
      list3: "Pošten naročniški model namesto dragih posameznih terapij.",
    },
    form: {
      title: "Prijava na čakalno listo",
      description: `Zagotovite si 30 % popust ob zagonu in zgodnja e‑poštna
                  obvestila o Revimu. Plačilo ni potrebno zdaj, le
                  rezervirate si svoje mesto.`,
      calling: "Kakšen bo tvoj vzdevek?",
      calling2: "Tvoja licenčna številka.",
      license: "Licenčna številka",
      name: "Ime",
      get_e:
        "Želim prejemati e‑poštna obvestila o Revimu in datumu zagona.",
      get_d:
        "Želim si rezervirati 30 % popust ob zagonu (plačilo šele ob zagonu).",
      warning: `S prijavo se strinjate, da lahko vaš e‑poštni naslov
                        uporabimo za obveščanje pred zagonom. Od prejemanja
                        obvestil se lahko kadarkoli odjavite.`,
    },
    joining1: "Prijavljamo...",
    joining2: "Prijava na čakalno listo",
    on_list: "Dodani ste na čakalno listo 🎉",
    thanks: "Hvala, ker ste si rezervirali mesto na Revimo.",
    add_info: `Po e‑pošti vas bomo obvestili o zagonu, vašem 30 % popustu
                      ter vam poslali tudi vprašalnik, s katerim boste lahko
                      pomagali soustvarjati platformo.`,
    add_o_e: "Dodaj še en e‑poštni naslov",
    error: "Nekaj je šlo narobe... Prosim da poiskusite ponovno."
  },
} as const;